import { animated, useSpring } from '@react-spring/three';
import { ReactNode } from 'react';

type Props = { children: ReactNode };

export const EnterAnimation = ({ children }: Props) => {
  const style = useSpring({
    from: { 'position-x': 100 },
    to: { 'position-x': 0 },
  });

  return <animated.group {...style}>{children}</animated.group>;
};
